// extracted by mini-css-extract-plugin
module.exports = {"bullet":"Bullet_bullet__1UFi_"};